module.exports = __webpack_public_path__ + "assets/img/3_1398.bea33b54.jpg";